export default "/images/login.png?0ca936fd1c9e6cd188a7d10373764ac8";